export interface ChangeWorkOrderStageMachine {
	machineId?: number;
	workOrderStageId: number;
}

export class ChangeWorkOrderStageMachine implements ChangeWorkOrderStageMachine {
	constructor(data?: Partial<ChangeWorkOrderStageMachine>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}